import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Roles } from '../../core/ucr-security/roles';
import { UcrSecurityService } from '../../core/ucr-security/ucr-security.service';
import { UserInfo } from '../../core/ucr-security/user-info';

@Injectable()
export class AuthGuardService {


    constructor(private ucrSecurity: UcrSecurityService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const redirectUrl = state?.url;
        return this.ucrSecurity.getUserInfo().pipe(
            map((ui: UserInfo) => {
                if (!this.ucrSecurity.isLoggedIn) {
                    this.ucrSecurity.login(redirectUrl);
                    return false;
                }

                if (route.data.fromRouteOnly) {
                    if (this.router.url !== route.data.fromRouteOnly) {
                        this.router.navigateByUrl(route.data.fromRouteOnly);
                        return false;
                    }
                }

                if (route.data.anyRoles && route.data.anyRoles.includes(Roles.permitAll)) {
                    return true;
                }

                if (route.data.anyRoles && ui.ifAnyGranted(route.data.anyRoles)) {
                    return true;
                } else if (route.data.allRoles && ui.ifAllGranted(route.data.allRoles)) {
                    return true;
                }
                this.router.navigate(['/notAuthorized']);
                return false;
            })
        );
    }
}
